<template>

    <div class="login-template">

        <div class="left-side">
            <div class="top">
                <a href="/" class="logo">
                    <logo></logo>
                </a>
            </div>
            <div class="login-content">
                <div class="content">
                    <h1>{{ $t('login.label.headline') }}</h1>
                    <form>
                        <div class="material-input">
                            <input id="email"
                                   type="email"
                                   v-model="form.email"
                                   class="form-control"
                                   name="email"
                                   required
                                   autofocus
                                   v-on="checkEmail"
                                   v-bind:class="{ active: isActiveEmail }"
                            >
                            <p class="label">
                                {{ $t('login.form.email') }}
                            </p>
                        </div>
                        <div class="material-input">
                            <input id="password"
                                   v-model="form.password"
                                   type="password"
                                   class="form-control"
                                   name="password"
                                   required
                                   v-on="checkPassword"
                                   v-bind:class="{ active: isActivePassword }"
                            >
                            <p class="label"><label for="password">{{ $t('login.form.password') }}</label></p>
                        </div>
                        <div class="button-container">
                            <button type="submit" :disabled="!validateInput || loggingIn" class="purple"
                                    @click.prevent="login">
                                <span v-if="!loggingIn">{{ $t('button.label.login') }}</span>
                                <span v-if="loggingIn">{{ $t('button.label.logging-in') }}</span>
                            </button>
                            <router-link to="/forgot-password">{{ $t('login.label.forgot-password') }}</router-link>
                        </div>
                    </form>
                    <router-link to="/register" class="other">{{ $t('login.label.no-account') }}
                        <span> {{ $t('login.label.signup') }}</span></router-link>
                </div>

            </div>
            <div class="bottom">
                <copyright></copyright>
                <span class="seperator">|</span>
                <a target="_blank" href="https://www.rently.dk/terms/">{{ $t('login.label.terms-conditions') }}</a>
            </div>
        </div>
        <div class="right-side">
            <div class="content">
                <div class="image">
                    <img src="/images/img/login-illustrationv2.png">
                </div>
                <div class="text"><h2>{{ $t('login.teaser.line-one') }}<br>{{ $t('login.teaser.line-two') }}</h2></div>
            </div>
        </div>
    </div>
</template>
<script>
import Logo from '../../components/Logo';
import Copyright from '../../components/Copyright';
import Form from 'vform';
import {mapGetters} from 'vuex';
import {store} from "../../store";


export default {
    async beforeRouteEnter(to, from, next) {
        if (store.getters.getToken) {
            next('/');
        }
        if (JSON.stringify(to.params).length > 2) {
            await store.dispatch('fetchEmailByHash', to.params.hash);
            next();
        } else {
            await store.commit('setEmail', '');
            next();
        }
    },
    data: () => ({
        loggingIn: false,
        isActivePassword: false,
        isActiveEmail: false,
        valid: true,
        isActive: false,
        form: new Form({
            email: '',
            password: ''
        }),
    }),
    mounted() {
        if (window.token !== undefined) {
            axios({method: 'GET', url: this.$root.apiUrl + 'api/login?auth_token=' + window.token}).then((response) => {
                this.$store.dispatch('login', response.data);
                this.$store.commit('setEmail', response.data.email);

                window.AuthorizationCancelSource = axios.CancelToken.source()

                store.dispatch('fetchUserSubscription');
                store.dispatch('fetchProperties');
                store.dispatch('fetchUserCompanies');

                this.$router.push('/');
            });
        }

        if (this.getToken) {
            console.info('Redirected back to dashboard, because user is logged in')
            this.$router.push('/');
        }
        if (this.$route.query.email) {
            this.form.email = this.$route.query.email;
        }
    },
    created() {
        this.form.email = this.getEmail;
    },
    computed: {
        validateInput() {
            return this.validEmail(this.form.email) && this.form.password;
        },
        checkEmail() {
            if (this.form.email === '' || this.form.email === null || this.form.email.value === 0) {
                this.isActiveEmail = false;
            } else {
                this.isActiveEmail = true;
            }
        },
        checkPassword() {
            if (this.form.password === '' || this.form.password === null || this.form.password.value === 0) {
                this.isActivePassword = false;
            } else {
                this.isActivePassword = true;
            }
        },
        ...mapGetters([
            'getToken',
            'getEmail',
            'getContractIdForSignature'
        ])
    },
    components: {
        Logo,
        Copyright
    },
    methods: {

        validEmail(email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        login() {

            this.loggingIn = true;
            axios({
                method: 'POST',
                url: window.config.apiUrl + 'api/login',
                data: {
                    email: this.form.email,
                    password: this.form.password
                }
            }).then(async (response) => {

                this.$store.dispatch('login', response.data);
                this.$store.commit('setEmail', this.form.email);

                window.AuthorizationCancelSource = axios.CancelToken.source()

                store.dispatch('fetchUserSubscription');
                store.dispatch('fetchProperties');
                store.dispatch('fetchUserCompanies');

                var contractIdForSignature = this.getContractIdForSignature;

                if (this.$route.query.open) {
                    window.open(window.config.apiUrl + this.$route.query.open + '?token=' + this.getToken);
                }

                if (this.$route.query.next) {
                    this.$router.push(this.$route.query.next);
                    return;
                }

                if (contractIdForSignature) {
                    store.dispatch('resetContractIdForSignature');
                    this.$router.push('/screening-info/' + contractIdForSignature);
                    return;
                }

                if (response.data.has_invitation) {
                    this.$router.push('/tenant-screening');
                    return;
                }

                this.$router.push('/');
            }).finally(() => {
                this.loggingIn = false;
            });
        }
    }
}
</script>
<style>
</style>
